module.exports = __webpack_public_path__ + "img/project-manager.483e6f13.svg";